import lodash from "lodash";
import { v4 as uuidv4 } from "uuid";
/**
 * 消息发送
 */
export class SubWindow {
  static formatColor(colorStr) {
    const c = convertColorFormat(colorStr);
    const { r: R, g: G, b: B, a: A } = c;
    return { R, G, B, A: A / 255 };
  }

  map = {};
  static getBaseUrl() {
    // let url = window.document.location.origin;
    // let envurl = process.env.VUE_APP_URL == "/" ? "" : process.env.VUE_APP_URL;
    // return url + (envurl == undefined ? "" : envurl) // 静态资源根路径

    let url = location.href;
    return url.substring(0, url.lastIndexOf("/")); //静态资源根路径
  }
  /**
   * 加载模型
   * @param opt
   */
  loadModel(opt) {
    opt = lodash.cloneDeep(opt);
    opt.id = typeof opt.id === "number" ? opt.id.toString() : opt.id;
    const fn = {
      tiles: this.handleTileset,
      TilesetLayer: this.handleTilesetLayer,
      model: this.handleModel,
      TileObjects: this.handleTileObjects,
      ModelLayer: this.handleModelLayer,
      xyzImagery: this.handleUrlTemplateImageryProvider,
      arcgisImagery: this.handleArcgisImagery,
      wmtsImagery: this.handleWmtsImagery,
      tdtImagery: this.handleTdtImagery,
      terrainProvider: this.handleTerrainProvider,
      FlattenMask: this.handleFlattenMask,
      RenderSystem: this.handleRenderSystem,
      geoJsonModel: this.handleGeoJsonModel,
      geoJsonPolylineLayer: this.handleGeoJsonPolylineLayer,
      geoJsonPolyline: this.handleGeoJsonPolylineLayer,
      MeshLayer: this.handleMeshLayer,
      geoJsonMeshLayer: this.handleMeshLayer,
      polygonDataSource: this.handlePolygonDataSource,
      ProjectionNode: this.handleProjectionNode,
      geoJsonPolygon: this.handleGeoJsonPolygonLayer,
      geoJsonPoint: this.hanldelGeoJsonPoint,
      SSmapLabel3D: (opt) => this.handleSSMapLabel3D(opt),
      Scene: this.handleScene,
    };
    fn[opt.dataType] && fn[opt.dataType](opt, opt.isChecked);
  }

  // 3dTileset
  handleTileset(opt, isOpen = true) {
    let modelOtherInfo = {};
    if (opt.modelOtherInfo) {
      let baseTypes = typeof opt.modelOtherInfo;
      if (baseTypes == "string") {
        try {
          modelOtherInfo = eval("(" + opt.modelOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        modelOtherInfo = opt.modelOtherInfo;
      }
    }
    const id = opt.id;
    const data = {
      title: opt.label,
      id: id,
      type: ["Tileset"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 请求头命名数组 为了设置多个请求头
        // headerList: [
        //   { headersKey: opt.headersKey },
        //   { headersKey: opt.headersKey },
        // ],
        // // 最大内存使用量
        // memoryusage: opt.memoryUsage,
        // // 3dtiles不显示低于某级的LOD
        // skipLevel: modelOtherInfo.skipLevel,
        // // 是否重新计算法线
        // meshNormals: modelOtherInfo.meshNormals,
        // // 几何误差比例
        // geometricErrorScale: opt.geometricErrorScale,
        // // 是否跳过LOD节点加载
        // skipLevelOfDetail: modelOtherInfo.skipLevelOfDetail,
        // // 是否裁切LOD
        // clipLevelOfDetail: modelOtherInfo.clipLevelOfDetail,
        // // 受光否
        // shadingModel: opt.isPhotic ? "MetallicRoughness" : "Unlit",
        // // 材质设置 OSGB 金属度的那个
        // format: opt.format,
        // 模型旋转角
        modelRotation: {
          heading: opt.rotation.x,
          pitch: opt.rotation.y,
          roll: opt.rotation.z,
        },
        // 模型偏移值
        modelOffset: {
          x: opt.offset.x,
          y: opt.offset.y,
          z: opt.offset.z,
        },
        compatible: true, //加载模式
        whileMoving: true, //开启剔除请求
        movingMultiplier: 0, //剔除请求速度
        // 纹理颜色
        // modelcolor:{ R: 0, G: 0, B: 0, A: 0 }
      },
    };
    Native.subWindow.postMessage(data);

    // 设置压平
    let rangeList = null;
    if (typeof opt.maskRange === "string") {
      try {
        rangeList = opt.maskRange && JSON.parse(opt.maskRange);
      } catch (e) {
        // console.log(e);
      }
    } else {
      rangeList = opt.maskRange;
    }

    rangeList &&
      Native.getLatlng(rangeList, (range) => {
        const message = {
          title: opt.id + "压平",
          id: id,
          isOpen,
          tilesetId: opt.maskObject.toString(),
          type: ["FlattenMask"],
          // url:'',
          properties: {
            rangeList: range,
            height: opt.maskHeight,
          },
        };
        Native.subWindow.postMessage(message);
      });
  }

  handleTilesetLayer(opt, isOpen = true) {
    let modelOtherInfo = {};
    if (opt.modelOtherInfo) {
      let baseTypes = typeof opt.modelOtherInfo;
      if (baseTypes == "string") {
        try {
          modelOtherInfo = eval("(" + opt.modelOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        modelOtherInfo = opt.modelOtherInfo;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["TilesetLayer"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 请求头命名数组 为了设置多个请求头
        headerList: [
          { headersKey: opt.headersKey },
          { headersKey: opt.headersKey },
        ],
        // 最大内存使用量
        memoryusage: opt.memoryUsage * 1024,
        // 3dtiles不显示低于某级的LOD
        skipLevel: modelOtherInfo.skipLevel,
        // 是否重新计算法线
        meshNormals: modelOtherInfo.meshNormals,
        // 几何误差比例
        geometricErrorScale: opt.geometricErrorScale,
        // 是否跳过LOD节点加载
        skipLevelOfDetail: modelOtherInfo.skipLevelOfDetail,
        // 是否裁切LOD
        clipLevelOfDetail: modelOtherInfo.clipLevelOfDetail,
        // 纹理颜色
        // modelcolor: null,
        // 受光否
        shadingModel: opt.isPhotic ? "MetallicRoughness" : "Unlit",
        // 材质设置 OSGB 金属度的那个
        format: opt.format,
        // 模型旋转角
        modelRotation: {
          heading: opt.modelRotationX,
          pitch: opt.modelRotationY,
          roll: opt.modelRotationZ,
        },
        // 模型偏移值
        modelOffset: {
          x: opt.modelOffsetX,
          y: opt.modelOffsetY,
          z: opt.modelOffsetZ,
        },
        compatible: true, //加载模式
        whileMoving: true, //开启剔除请求
        movingMultiplier: 0, //剔除请求速度
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleModel(opt, isOpen = true) {
    let modelOtherInfo = {};
    if (opt.modelOtherInfo) {
      let baseTypes = typeof opt.modelOtherInfo;
      if (baseTypes == "string") {
        try {
          modelOtherInfo = eval("(" + opt.modelOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        modelOtherInfo = opt.modelOtherInfo;
      }
    }
    let watermaterial, watercolor;
    if (opt.waterMaterial == "2") {
      // watermaterial = true;
      watercolor = opt.colorMaterial.match(/(\d(\.\d+)?)+/g);
    } else if (opt.waterMaterial == "3") {
      watermaterial = true;
    }
    const colorByNames = (modelOtherInfo.colorByNames || []).map((i) => {
      i.color = SubWindow.formatColor(i.color);
      return i;
    });
    opt.isPhotic = true; // 默认受光
    // const posit = jsonToVec3(opt.position);

    const data = {
      title: opt.label,
      id: opt.id,
      type: ["Model"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 模型坐标值
        carto: {
          x: opt.position.longitude,
          y: opt.position.latitude,
          z: opt.position.height,
        },
        // 模型旋转角
        rotation: opt.rotation
          ? {
              heading: opt.rotation.x,
              pitch: opt.rotation.y,
              roll: opt.rotation.z,
            }
          : undefined,
        // 模型偏移值
        // offset: {
        //   x: opt.modelOffsetX,
        //   y: opt.modelOffsetY,
        //   z: opt.modelOffsetZ,
        // },
        // 模型大小
        scale: { x: 1, y: 1, z: 1 },
        // 凹凸平铺数量 水纹理的设置
        bumpTilling:
          modelOtherInfo.bumpTilling !== undefined
            ? Number(modelOtherInfo.bumpTilling)
            : modelOtherInfo.bumpTilling,
        // 波浪角度 水纹理的设置
        flowAngle:
          modelOtherInfo.flowAngle !== undefined
            ? Number(modelOtherInfo.flowAngle)
            : modelOtherInfo.flowAngle,
        // 流速 水纹理的设置
        flowSpeed:
          modelOtherInfo.flowSpeed !== undefined
            ? Number(modelOtherInfo.flowSpeed)
            : modelOtherInfo.flowSpeed,
        // 反射颜色系数 水纹理的设置
        specularFactor:
          modelOtherInfo.specularFactor !== undefined
            ? Number(modelOtherInfo.specularFactor)
            : modelOtherInfo.specularFactor,
        // 纹理颜色
        watercolor: watercolor
          ? {
              R: Number(watercolor[0]),
              G: Number(watercolor[1]),
              B: Number(watercolor[2]),
              A: watercolor[3] * 255,
            }
          : undefined,
        // 受光否
        shadingModel: opt.isPhotic ? "MetallicRoughness" : "Unlit",
        // 水材质开启否
        watermaterial: watermaterial,
        // 控制glb中不同ObjectName的颜色 [{"name":"JCJK_SJD","color":"rgba(255,237,102,1)"},{"name":"JCJK_GDM","color":"rgba(170,0,255,1)"},{"name":"JCJK_QSPSM","color":"rgba(191,255,0,1)"},{"name":"JCJK_ZAW_AXM","color":"rgba(240,255,255,1)"},{"name":"JCJK_NSPM","color":"rgba(0,255,255,1)"},{"name":"JCJK_ZXM","color":"rgba(255,102,255,1)"},{"name":"JCJK_3Qu_A","color":"rgba(0,255,0,1)"},{"name":"JCJK_3Qu_B","color":"rgba(0,255,0,1)"},{"name":"JCJK_2Qu","color":"rgba(255,0,0,1)"},{"name":"JCJK_1Qu","color":"rgba(0,102,255,0.5)"},{"name":"JCJK_1Qu001","color":"rgba(0,102,255,0.5)"}]
        // colorByNames: modelOtherInfo.colorByNames || [],
        colorByNames,
      },
    };
    if (!watermaterial) {
      delete data.properties.watermaterial;
    }

    // Native.flyDegrees(opt.position, (p) => {
    //   console.log("p", p);
    // });
    // Native.Model.flyTo(opt); 不知道模型加载完成时间
    // console.log("model", data);
    Native.subWindow.postMessage(data);

    // 设置压平
    let rangeList = null;
    if (typeof opt.maskRange === "string") {
      try {
        rangeList = opt.maskRange && JSON.parse(opt.maskRange);
      } catch (e) {
        // console.log(e);
      }
    } else {
      rangeList = opt.maskRange;
    }
    Native.getLatlng(rangeList, (range) => {
      // console.log("遮罩范围", range);
      const message = {
        title: opt.id + "压平",
        id: opt.id,
        isOpen,
        tilesetId: opt.maskObject.toString(),
        type: ["FlattenMask"],
        // url:'',
        properties: {
          rangeList: range,
          height: opt.maskHeight,
        },
      };
      Native.subWindow.postMessage(message);
    });
  }

  handleTileObjects(opt, isOpen = true) {
    let modelOtherInfo = {};
    if (opt.modelOtherInfo) {
      const baseTypes = typeof opt.modelOtherInfo;
      if (baseTypes === "string") {
        try {
          modelOtherInfo = eval("(" + opt.modelOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        modelOtherInfo = opt.modelOtherInfo;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["TileObjects"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 模型坐标值
        carto: {
          x: opt.modelPositionX,
          y: opt.modelPositionY,
          z: opt.modelPositionZ,
        },
        // 超出则剔除
        distance: modelOtherInfo.distance,
        // 是否投射阴影 true
        castShadow: modelOtherInfo.castShadow,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleModelLayer(opt, isOpen = true) {
    let modelOtherInfo = {};
    if (opt.modelOtherInfo) {
      let baseTypes = typeof opt.modelOtherInfo;
      if (baseTypes == "string") {
        try {
          modelOtherInfo = eval("(" + opt.modelOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        modelOtherInfo = opt.modelOtherInfo;
      }
    }
    // 材质
    let watermaterial, watercolor;
    if (opt.waterMaterial == "2") {
      watermaterial = true;
      watercolor = opt.colorMaterial.match(/(\d(\.\d+)?)+/g);
    } else if (opt.watercolor == "3") {
      watermaterial = true;
      // watercolor = this.hexify(opt.colorMaterial);
    }

    const cullDistance = opt.cullDistance ? opt.cullDistance : 500;
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["ModelLayer"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 模型坐标值
        carto: {
          x: opt.modelPositionX,
          y: opt.modelPositionY,
          z: opt.modelPositionZ,
        },
        // 模型旋转角
        rotation: {
          heading: opt.modelRotationX,
          pitch: opt.modelRotationY,
          roll: opt.modelRotationZ,
        },
        // 模型偏移值
        offset: {
          x: opt.modelOffsetX,
          y: opt.modelOffsetY,
          z: opt.modelOffsetZ,
        },
        // 纹理颜色
        watercolor: watercolor,
        // 水材质开启否
        watermaterial: watermaterial,
        // 距离 []
        distance: [0, cullDistance],
        // 阴影
        castShadow: modelOtherInfo.castShadow,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleUrlTemplateImageryProvider(opt, isOpen = true) {
    let joinUrl = "/{z}/{x}/{y}.png";
    if (opt.joinUrl) {
      if (opt.joinUrl.indexOf("/") == 0) {
        joinUrl = opt.joinUrl;
      } else {
        joinUrl = "/" + opt.joinUrl;
      }
    }

    //范围
    let imageryRectangle = [-180, -90, 180, 90];
    if (opt.imageryRectangle) {
      if (Array.isArray(opt.imageryRectangle)) {
        imageryRectangle = opt.imageryRectangle.map((v) => Number(v));
      } else {
        imageryRectangle = opt.imageryRectangle;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["UrlTemplateImageryProvider"],
      url: opt.url + joinUrl,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 请求头命名数组 为了设置多个请求头
        headerList: [{ headersKey: opt.headersKey }],
        // 空间的坐标范围
        rectangle: imageryRectangle,
        // 卡托
        useWebMercator: opt.useWebMercator,
        // 最大层级
        maximumLevel: Number(opt.maximumLevel) || 17,
        // 最小层级
        minimumLevel: Number(opt.minimumLevel) || 1,
        // 瓦片宽度
        tileWidth: Number(opt.tileWidth) || 256,
        // 瓦片高度
        tileHeight: Number(opt.tileHeight) || 256,
        // 阿尔法
        hasAlphaChannel: opt.hasAlphaChannel,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleArcgisImagery(opt, isOpen = true) {
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["ArcgisImagery"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {},
    };
    Native.subWindow.postMessage(data);
  }

  handleWmtsImagery(opt, isOpen = true) {
    //范围
    let imageryRectangle = [-180, -90, 180, 90];
    if (opt.imageryRectangle) {
      if (Array.isArray(opt.imageryRectangle)) {
        imageryRectangle = opt.imageryRectangle.map((v) => Number(v));
      } else {
        imageryRectangle = opt.imageryRectangle;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["WmtsImagery"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {},
    };
    Native.subWindow.postMessage(data);
  }

  handleTdtImagery(opt, isOpen = true) {
    let OpterInfo = {};
    if (opt.imageryOpterInfo) {
      let baseTypes = typeof opt.imageryOpterInfo;
      if (baseTypes == "string") {
        try {
          OpterInfo = eval("(" + opt.imageryOpterInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        OpterInfo = opt.imageryOpterInfo;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["TdtImagery"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        useWebMercator: opt.useWebMercator || false, //使用卡托否
        maximumLevel: Number(opt.maximumLevel) || 17, //最大层级
        minimumLevel: Number(opt.minimumLevel) || 1, //最小层级
        tileWidth: Number(opt.tileWidth) || 256, //瓦片宽度
        tileHeight: Number(opt.tileHeight) || 256, //瓦片长度
        hasAlphaChannel: opt.hasAlphaChannel || false, //使用阿尔法否
        isLabel: OpterInfo.isLabel || false, // 标记否
        lighting: opt.lightingEnabled || true,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleTerrainProvider(opt, isOpen = true) {
    let terrainOpterInfo = {};
    if (opt.terrainOpterInfo) {
      let baseTypes = typeof opt.terrainOpterInfo;
      if (baseTypes == "string") {
        try {
          terrainOpterInfo = eval("(" + opt.terrainOpterInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        terrainOpterInfo = opt.terrainOpterInfo;
      }
    }
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["setTerrainProviderUrl"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 请求头命名数组 为了设置多个请求头
        headerList: [
          { headersKey: opt.headersKey },
          { headersKey: opt.headersKey },
        ],
        // 地形的水开启否
        watermask: terrainOpterInfo.watermask,
        // 地形的透明度
        opacity: terrainOpterInfo.opacity,
      },
    };

    Native.subWindow.postMessage(data);
  }

  handleFlattenMask(opt, isOpen = true) {
    // console.log("压平");
    Native.getLatlng(opt.maskRange, (range) => {
      // console.log("遮罩范围", range);
      const data = {
        title: opt.label,
        id: opt.id,
        // 压平的对象id  地形 globe
        tilesetId: opt.tilesetId,
        type: ["FlattenMask"],
        url: opt.url,
        methods: {},
        isOpen,
        order: 0,
        properties: {
          // 遮罩高度
          height: opt.maskHeight,
          // 遮罩范围
          rangeList: range,
        },
      };
      Native.subWindow.postMessage(data);
    });
  }

  handleScene(opt, isOpen = true) {
    const { globeLighting, fog } = opt;
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["Scene"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        globeLighting,
        // globeopacity,
        fog,
      },
    };
    // console.log(data);
    Native.subWindow.postMessage(data);
  }

  handleRenderSystem(opt, isOpen = true) {
    const {
      antiAliasing,
      autoExposure,
      bloomValue,
      blueCorrection,
      brightThreshold,
      contrast,
      exposure,
      upscaleCount,
      shutterSpeed,
      indirectLight,
      saturation,
      sharpen,
      sunintensity,
      toneCurveAmount,
      whiteTemp,
      aoQuality,
      aoRadius,
      aoAmount,
      aoFadeIn,
      hdRmodelimg,
      hdrDiffuseIntensity,
      hdrSpecularIntensity,
      hdrRotation,
      time,
      atmIntensity,
      atmInscatterAmount,
      globalLight,
    } = opt;
    const data = {
      title: opt.label || "场景设置",
      id: opt.id || uuidv4(),
      type: ["RenderSystem"],
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 抗锯齿
        antiAliasingList: antiAliasing,
        // 自动曝光
        autoExposure,
        // 泛光值
        bloomValue,
        // 蓝光修正
        blueCorrection,
        // 亮度阈值
        brightThreshold,
        // 对比度
        contrast,
        // 曝光
        exposure,
        // 渲染质量
        upscaleCount,
        // 相机快门
        shutterSpeed: 1 / shutterSpeed,
        // 环境光强度 环境光
        indirectLight,
        // 饱和度
        saturation,
        // 锐化
        sharpen,
        // 太阳光强度 光照调节
        sunintensity,
        // 色调映射 色调曲线值
        toneCurveAmount,
        // 色温
        whiteTemp,
        // AO质量
        aoquality: aoQuality,
        // AO半径
        aoRadius,
        // AO数量
        aoamount: aoAmount,
        // 渐入时间
        aofadeIn: aoFadeIn,
        // 贴图路径
        hdRmodelimg,
        // 漫反射强度
        hdRdiffuseIntensity: hdrDiffuseIntensity,
        // 镜面反射强度
        hdRspecularIntensity: hdrSpecularIntensity,
        hdRrotation: hdrRotation,
        // 时间
        time,
        // // 天空亮度
        atmIntensity,
        // // 大气散射
        atmInscatterAmount,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleGeoJsonModel(opt, isOpen = true) {
    let geoJsonOtherInfo = {};
    if (opt.geoJsonOtherInfo) {
      let baseTypes = typeof opt.geoJsonOtherInfo;
      if (baseTypes == "string") {
        try {
          geoJsonOtherInfo = eval("(" + opt.geoJsonOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        geoJsonOtherInfo = opt.geoJsonOtherInfo;
      }
    }
    const iconList = [
      "data/icon/label-orange.png",
      "data/icon/label-dark-blue.png",
      "data/icon/label-blue.png",
      "data/icon/label-green.png",
      "data/icon/label-yellow.png",
    ];
    const data = {
      title: opt.url,
      id: opt.id,
      // geojson 文件路径
      url: opt.url,
      type: ["GeoJsonModel"],
      // geojson 字符串 点
      // geojosnString:opt.geojosnString,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 图标路径
        iconUrl:
          getBaseUrl() +
          "/" +
          (iconList[geoJsonOtherInfo.iconType - 1]
            ? iconList[geoJsonOtherInfo.iconType - 1]
            : "data/icon/label-orange.png"), //图标链接,
        // 被选中的图标路径
        selectediconUrl:
          getBaseUrl() +
          "/" +
          (iconList[geoJsonOtherInfo.iconType - 1]
            ? iconList[geoJsonOtherInfo.iconType - 1]
            : "data/icon/label-orange.png"), //选中图标链接
        // 图标宽度
        iconwidth: geoJsonOtherInfo.iconWidth || 40,
        // 图标高度
        iconheight: geoJsonOtherInfo.iconHeight || 50,
        // 字体x轴偏移量
        labeloffsetx: -10,
        // 字体 y轴 偏移量
        labeloffsety: -10,
        // 图标 偏移量 无效
        iconoffsetx: 0,
        // 图标 偏移量 无效
        iconoffsety: 0,
        // 距离比例
        scaleDistance: geoJsonOtherInfo.scaleDistance,
        // 距离
        distance: [1, geoJsonOtherInfo.distance],
        // 图标高度
        height: 0,
        // 标签字段
        labelField: geoJsonOtherInfo.labelField,
        // 添加字段 写入GeojsonModel中，便于拾取
        // FieldList: [ '进出类型', '卡口', 'index' ],
        // 聚合否
        clustered: true,
        // 是否替换要素
        replace: true,
        // 垂线显示隐藏
        lineToGround: false,
        // 垂线的颜色
        // lineColor: { R: 0, G: 0, B: 0, A: 128 },
        // 根据距离更新高度
        updateHeightByDistance: geoJsonOtherInfo.updateHeightByDistance,
        fontSize: Number(geoJsonOtherInfo.fontSize) + 4, //字体大小
      },
    };
    if (!geoJsonOtherInfo.distance) delete data.distance;
    Native.subWindow.postMessage(data);
  }

  handleGeoJsonPolylineLayer(opt, isOpen = true) {
    let modelInfo = {}
    if (typeof opt.modelInfo === 'string') {
      try { modelInfo = JSON.parse(opt.modelInfo) } catch (e) {}
    } else if (typeof opt.modelInfo === 'object') {
      modelInfo = opt.modelInfo
    }
    const lineColor = opt.lineColor || modelInfo.lineColor
    const fillColor = SubWindow.formatColor(lineColor);
    fillColor.A *= 255;
    const lineWidth = opt.lineWidth != undefined ? opt.lineWidth : (modelInfo.lineWidth != undefined ? modelInfo.lineWidth : 1)
    const glow = opt.glow != undefined ? opt.glow : (modelInfo.glow || false)
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["GeoJsonPolylineLayer"],
      // geojson文件路径
      url: opt.url,
      // geoJson 字符串 点
      geojosnString: "",
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 线的填充颜色
        fillColor,
        // 线的透明度
        lineAlpha: fillColor.A / 255 || 1,
        // 线的宽度
        lineWidth: lineWidth,
        // 线发光否
        glow: glow,
        // 动画否
        animationRun: false,
        // 设置动画周期(ms)
        animationTimer: 5000,
        // 设置自发光强度
        // glowPower:0.5,
        // 海拔模式(Absolute-绝对高度 RelativeToTerrain-贴地(直线，有曲面跟随) OnTerrain-贴地)
        altitudeMethod: opt.altitudeMethod,
        // altitudeMethod === ’Absolute‘ 生效
        altitude: opt.altitude,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleMeshLayer(opt, isOpen = true) {
    const fillColor = SubWindow.formatColor(opt.colorMaterial);
    fillColor.A *= 255;
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["MeshLayer"],
      // mesh文件路径
      url: opt.url,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 面的填充颜色
        fillColor,
        // 贴图纹理url
        // textureUrl:''
      },
    };
    Native.subWindow.postMessage(data);
  }

  handlePolygonDataSource(opt, isOpen = true) {
    const fillColor = SubWindow.formatColor(opt.colorMaterial);
    fillColor.A *= 255;
    const selectedColor = SubWindow.formatColor(
      opt.selectedColor || "rgba(0,0,0,0)"
    );
    selectedColor.A *= 255;
    const strokeColor = SubWindow.formatColor(opt.lineColor);
    const data = {
      title: opt.label,
      id: opt.id,
      type: ["ProjectionLayer", "ProjectionDataSource"],
      // mesh文件路径
      url: opt.url,
      // geojosn 字符串 点
      // geojosnString:opt.geojosnString,
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // 面的填充颜色
        fillColor,
        // 被选中的面填充颜色
        selectedColor,
        // 描边颜色
        strokeColor,
        // 描边宽度
        strokeWidth: opt.lineWidth,
        // 需要拾取的字段
        fieldList: [],
        // 给ProjectionLayer 中的sceneMode属性，设置参数
        layerSceneMode: "WholeScene", // 'TerrainOnly'
      },
    };
    Native.subWindow.postMessage(data);
  }
  // 暂时未使用
  handleProjectionNode(opt, isOpen = true) {
    const data = {
      title: "投影面",
      id: opt.id,
      type: ["ProjectionLayer", "ProjectionNode"],
      methods: {},
      isOpen,
      order: 0,
      properties: {
        // ProjectionNode 的面坐标
        points: [
          [112.1, 21.2, 0],
          [112.1, 21.2, 0],
        ],
        // 面的填充颜色
        fillColor: { R: 0, G: 0, B: 0, A: 128 },
        // 被选中的面填充颜色
        selectedColor: { R: 0, G: 0, B: 0, A: 128 },
        // 描边颜色
        strokeColor: { R: 0, G: 0, B: 0, A: 128 },
        // 描边宽度
        strokeWidth: 10,
        // 需要拾取的字段
        fieldList: [],
        // 给ProjectionLayer 中的sceneMode属性，设置参数
        layerSceneMode: opt.layerSceneMode,
      },
    };
    Native.subWindow.postMessage(data);
  }

  handleGeoJsonPolygonLayer(opt, isOpen = true) {
    let modelInfo = {}
    if (typeof opt.modelInfo === 'string') {
      try { modelInfo = JSON.parse(opt.modelInfo) } catch (e) {}
    } else if (typeof opt.modelInfo === 'object') {
      modelInfo = opt.modelInfo
    }
    let fillColor,
      lineColor = { R: 0, G: 0, B: 0, A: 255 },
      fieldStr;
    const _fillColor = opt.fillColor || modelInfo.fillColor
    const _lineColor = opt.lineColor || modelInfo.lineColor
    const _lineWidth = opt.lineWidth || modelInfo.lineWidth
    const _fillAlpha = opt.fillAlpha || modelInfo.fillAlpha
    if (_fillColor) {
      fillColor = SubWindow.formatColor(_fillColor);
      fillColor.A *= 255;
    }
    if (_lineColor) {
      lineColor = SubWindow.formatColor(_lineColor);
      lineColor.A *= 255;
    }

    if (Array.isArray(opt.legendList) && opt.legendList.length) {
      const { color } = opt.legendList[0];
      lineColor = SubWindow.formatColor(color);
      lineColor.A *= 255;
    }

    if (opt.disposition) {
      if (
        Array.isArray(opt.disposition.dispositionList) &&
        opt.disposition.dispositionList.length
      ) {
        const { fillColorField } = opt.disposition.dispositionList[0];
        fillColor = SubWindow.formatColor(fillColorField);
        fillColor.A *= 255;
      }

      fieldStr = opt.disposition.field;
    }

    const data = {
      title: opt.label,
      id: opt.id,
      type: ["GeoJsonPolygonLayer"],
      isOpen,
      // mesh文件路径
      url: opt.url,
      // geojosn 字符串 点
      geojosnString: "", // opt.geojosnString,
      methods: {},
      order: 0,
      properties: {
        // PLANE (片（边线加填充）)  LINE("线（只有边线）")   NoType(没有类型)
        entityType: "PLANE",
        // 面的填充颜色
        fillColor: fillColor
          ? {
              R: fillColor.R,
              G: fillColor.G,
              B: fillColor.B,
              A: fillColor.A,
            }
          : undefined, // 面的边框线颜色
        lineColor: lineColor,
        colorField: opt.colorField || "colorField", //面线框颜色,
        fillColorField: opt.fillColorField || "fillColorField", //面填充颜色
        // 面的透明度
        fillAlpha: _fillAlpha || 0.9,
        // 设置选中的颜色
        pickColor: { R: 0, G: 0, B: 0, A: 128 },
        lineWidth: _lineWidth || 1,
        // 设置id关联的字段
        idField: "",
        // 设置粒度
        granularity: 5,
        // 海拔模式 (Absolute-绝对高度  RelativeToTerrain-贴地(直线， 有曲面跟随)  OnTerrain-贴地)
        altitudeMethod: "Absolute",
        // 海拔值 只有海拔模式(Absolute-绝对高度  RelativeToTerrain-贴地(直线， 有曲面跟随))才生效
        altitude: opt.altitude || 100,
        // ...opt.properties,
      },
    };
    // console.log("GeoJsonPolygonLayer", opt.label, data);
    Native.subWindow.postMessage(data);
  }
  hanldelGeoJsonPoint(opt, isOpen) {
    const background = SubWindow.formatColor(opt.backgroundColor);
    background.A *= 255;
    const fontColor = SubWindow.formatColor(opt.fontColor);
    fontColor.A *= 255;
    const strokeColor = SubWindow.formatColor(opt.strokeColor);
    strokeColor.A *= 255;

    let iconUrl;
    if (!opt.iconUrl) {
      iconUrl = "images/point-icon/1-黑-未选中@2x.png";
    } else {
      iconUrl = opt.iconUrl;
    }
    if (opt.iconColor) {
      iconUrl = iconUrl.replace(/(-)([^-]+)(-未选中)/, `$1${opt.iconColor}$3`);
    }
    iconUrl = SubWindow.getBaseUrl() + "/" + iconUrl;

    const data = {
      id: opt.id,
      isOpen,
      order: 0,
      title: opt.label,
      isEnabled: true,
      type: ["GeoJsonLabelLayer"],
      geojosnString: "",
      url: opt.url,
      methods: {},
      properties: {
        background: {
          R: background.R,
          G: background.G,
          B: background.B,
          A: background.A,
        },
        fontColor: {
          R: fontColor.R,
          G: fontColor.G,
          B: fontColor.B,
          A: fontColor.A,
        },
        strokeColor: {
          R: strokeColor.R,
          G: strokeColor.G,
          B: strokeColor.B,
          A: strokeColor.A,
        },
        iconSize: [opt.iconSize, opt.iconSize],
        iconUrl: iconUrl,
        nameField: opt.labelField || "defaultName",
      },
    };
    // console.log("point", data);
    Native.subWindow.postMessage(data);
  }

  handleSSMapLabel3D(opt, isOpen = true) {
    if (this.map[opt.dataSourceName]) {
      const data = {
        isOpen: true,
        isEnabled: true,
        type: ["BillboardCollection"],
        bbcollectionname: opt.dataSourceName,
      };
      Native.subWindow.postMessage(data);
      return;
    }
    let geoJsonOtherInfo = {};
    if (opt.geoJsonOtherInfo) {
      let baseTypes = typeof opt.geoJsonOtherInfo;
      if (baseTypes == "string") {
        try {
          geoJsonOtherInfo = eval("(" + opt.geoJsonOtherInfo + ")");
        } catch (error) {
          // console.log(error);
        }
      } else {
        geoJsonOtherInfo = opt.geoJsonOtherInfo;
      }
    }
    let iconList = [
      "data/icon/label-orange.png",
      "data/icon/label-dark-blue.png",
      "data/icon/label-blue.png",
      "data/icon/label-green.png",
      "data/icon/label-yellow.png",
    ];
    let nowAltitude = 15;
    let nowfontColor =
      geoJsonOtherInfo.fontColor &&
      geoJsonOtherInfo.fontColor.match(/(\d(\.\d+)?)+/g);
    let nowStrokeColor =
      geoJsonOtherInfo.fontStrokeColor &&
      geoJsonOtherInfo.fontStrokeColor.match(/(\d(\.\d+)?)+/g);
    let nowBackgroundColor =
      geoJsonOtherInfo.backgroundColor &&
      geoJsonOtherInfo.backgroundColor.match(/(\d(\.\d+)?)+/g);
    let nowUrl = iconList[geoJsonOtherInfo.iconType - 1];
    if (geoJsonOtherInfo.iconType == undefined) {
      nowUrl = iconList[0];
    }
    let newStrokeColor = undefined,
      newBackgroundColor = undefined,
      newfontColor = undefined;
    if (!nowfontColor) {
      newfontColor = {
        R: 255,
        G: 255,
        B: 255,
        A: 255,
      };
    } else {
      newfontColor = {
        R: Number(nowfontColor[0]),
        G: Number(nowfontColor[1]),
        B: Number(nowfontColor[2]),
        A: Number(nowfontColor[3]) * 255,
      };
    }
    if (geoJsonOtherInfo.fontMaterial === "2") {
      newStrokeColor = {
        R: Number(nowStrokeColor[0]),
        G: Number(nowStrokeColor[1]),
        B: Number(nowStrokeColor[2]),
        A: Number(nowStrokeColor[3]) * 255,
      };
    } else if (geoJsonOtherInfo.fontMaterial === "1") {
      newBackgroundColor = {
        R: Number(nowBackgroundColor[0]),
        G: Number(nowBackgroundColor[1]),
        B: Number(nowBackgroundColor[2]),
        A: Number(nowBackgroundColor[3]) * 255,
      };
    }
    let that = this;
    const loadLabel3d = (nowFeatures) => {
      for (let i = 0; i < nowFeatures.length; i++) {
        let nowFeature = nowFeatures[i];
        let data = {
          title: opt.name,
          id: opt.dataSourceName + "_" + i, // 必须为字符串
          type: ["Label3D"],
          isOpen,
          // url: opt.url,
          methods: {},
          order: 0,
          properties: {
            bbcollectionname: opt.dataSourceName, //  bbcollectionname
            storage: opt.dataSourceName, // 存储容器名称
            depthTest: true, //深度检测
            altitudeMethod: "Absolute", //海拔模式
            position: [
              parseFloat(nowFeature.geometry.coordinates[0]),
              parseFloat(nowFeature.geometry.coordinates[1]),
              parseFloat(nowAltitude),
            ], // 经纬度
            text:
              nowFeature.properties[geoJsonOtherInfo.labelField || "NAME"] ||
              "", // 文本
            fontSize: geoJsonOtherInfo.fontSize,
            fontColor: newfontColor,
            strokeColor: newStrokeColor, // 描边 （不能和background同时存在）
            backgroundColor: newBackgroundColor,
            columnField: geoJsonOtherInfo.mapFields, // 拾取字段
            url: getBaseUrl() + "/" + nowUrl, // 图片url
            imageWidth: geoJsonOtherInfo.iconWidth,
            imageHeight: geoJsonOtherInfo.iconHeight,
            offset: { x: 0, y: -10 },
            scaleByDistance: {
              x: geoJsonOtherInfo.scaleByDistanceX || 10,
              y: geoJsonOtherInfo.scaleByDistanceY || 1.0,
              z: geoJsonOtherInfo.scaleByDistanceZ || 1.0e6,
              w: geoJsonOtherInfo.scaleByDistanceW || 1.0,
            }, // 根据距离比例缩放
            fontDistance: geoJsonOtherInfo.fontDistance, // 字体距离显示
            translucencyByDistance: { x: 30000, y: 1.0, z: 1.0e6, w: 0.7 }, // 透明度比例缩放
            scale: geoJsonOtherInfo.fontScale, // 比例大小
          },
        };
        that.map[opt.dataSourceName] = true;
        Native.subWindow.postMessage(data);
      }
    };
    if (opt.url.includes("http")) {
      let request = new XMLHttpRequest();
      request.open("get", opt.url); /* 设置请求方法与路径 */
      request.send(null); /* 不发送数据到服务器 */
      request.onload = () => {
        if (!request.status == 200) return;
        let geojsonData = JSON.parse(request.responseText);
        let nowFeatures = geojsonData.features;
        loadLabel3d(nowFeatures);
      };
    } else {
      Native.readFileAsString(
        { filename: opt.url, encryption: false },
        (responseText) => {
          if (!responseText) return;
          let strtype = typeof responseText;
          let geojsonData = null;
          if (strtype == "string") {
            geojsonData = JSON.parse(responseText);
          }
          if (!geojsonData) return;
          let nowFeatures = geojsonData.features;
          if (nowFeatures.length >= 300) {
            this.handleGeoJsonModel(opt, isOpen);
          } else {
            loadLabel3d(nowFeatures);
          }
        }
      );
    }
  }

  handleSceneSetting() {
    const data = {
      type: ["Scene"],
      isOpen: true,
      properties: {
        // 地表反光
        globeLighting: true,
        // 地表透明
        globeOpacity: 0.9,
        // 雾效
        fog: true,
      },
    };
    Native.subWindow.postMessage(data);
  }

  /**
   * 删除模型
   */
  removeModel(opt) {
    opt = lodash.cloneDeep(opt);
    opt.id = typeof opt.id === "number" ? opt.id.toString() : opt.id;
    const fn = {
      tiles: this.handleTileset,
      TilesetLayer: this.handleTilesetLayer,
      model: this.handleModel,
      TileObjects: this.handleTileObjects,
      ModelLayer: this.handleModelLayer,
      xyzImagery: this.handleUrlTemplateImageryProvider,
      arcgisImagery: this.handleArcgisImagery,
      WmtsImagery: this.handleWmtsImagery,
      tdtImagery: this.handleTdtImagery,
      terrainProvider: this.handleTerrainProvider,
      FlattenMask: this.handleFlattenMask,
      RenderSystem: this.handleRenderSystem,
      geoJsonModel: this.handleGeoJsonModel,
      geoJsonPolylineLayer: this.handleGeoJsonPolylineLayer,
      geoJsonPolyline: this.handleGeoJsonPolylineLayer,
      MeshLayer: this.handleMeshLayer,
      geoJsonMeshLayer: this.handleMeshLayer,
      polygonDataSource: this.handlePolygonDataSource,
      ProjectionNode: this.handleProjectionNode,
      geoJsonPolygon: this.handleGeoJsonPolygonLayer,
      geoJsonPoint: this.hanldelGeoJsonPoint,
      SSmapLabel3D: (opt, isOpen) => this.handleRemoveSSMapLabel3D(opt, isOpen),
    };
    fn[opt.dataType] && fn[opt.dataType](opt, false);
  }

  handleRemoveSSMapLabel3D(opt, isOpen) {
    if (this.map[opt.dataSourceName]) {
      const data = {
        isOpen: true,
        isEnabled: false,
        type: ["BillboardCollection"],
        bbcollectionname: opt.dataSourceName,
      };
      Native.subWindow.postMessage(data);
    } else {
      this.handleSSMapLabel3D(opt, isOpen);
    }
  }

  /**
   * 创建子窗口
   */
  create(url) {
    Native.subWindow.addSubwindow(url || process.env.VUE_APP_AUTHORIZEDURL, () => {
      this.addAuthorized();
      Native.defaultSceneSetting();
    });
  }

  /**
   * 移除子窗口
   */
  remove() {
    this.map = {};
    Native.subWindow.removeSubwindow();
  }

  /**
   * 添加授权
   */
  addAuthorized() {
    const data = {
      title: "授权",
      id: uuidv4(),
      type: ["AuthorizedUrl"],
      url: process.env.VUE_APP_AUTHORIZEDURL,
      properties: {},
      methods: {},
      isOpen: true,
      order: 0,
    };
    Native.subWindow.postMessage(data);
  }
}
export const subWindow = new SubWindow();

/**
 * @description 处理主屏的参数 适配子屏所需格式
 * @param {object} 主屏参数
 * */

export const mainScreenToSecondaryScreenInfo = function (mainScreenInfo) {
  const { dataType, modelInfo, ...res } =
    mainScreenInfo;
  let opt = {
    dataType,
    ...(modelInfo || {}),
    ...res,
  };

  if (
    ["geoJsonPoint", "geoJsonPolyline", "geoJsonPolygon"].includes(dataType)
  ) {
    opt = filterGeoJson(opt);
  }
  if (dataType === "tdtImagery") {
    subWindow.loadModel({ dataType: "Scene" });
  }
  // console.log("副屏接收参数", opt);
  subWindow.loadModel(opt);
};

const filterGeoJson = (opt) => {
  const { dataType, modelInfo } = opt;
  switch (dataType) {
    case "geoJsonPolyline":
      break;
    case "geoJsonPolygon":
      break;
    case "geoJsonPoint":
      break;

    default:
      break;
  }
  return opt;
};

/**
 * 颜色格式转换
 * @param {string} colorString - 颜色字符串。
 * @returns {string} - rbga格式颜色字符串
 */
export function convertColorFormat(colorString) {
  let result;

  // 移除字符串中的空格
  colorString = colorString.replace(/\s/g, "");

  // 如果是 #RRGGBB 或 #RRGGBBAA 格式
  const hexMatch = colorString.match(
    /^#(?:([0-9a-fA-F]{3}){1,2}|([0-9a-fA-F]{4}){1,2})$/
  );
  if (hexMatch) {
    const hexValue = hexMatch[0].substring(1); // 去掉 #

    result = {
      r: parseInt(hexValue.substring(0, 2), 16),
      g: parseInt(hexValue.substring(2, 4), 16),
      b: parseInt(hexValue.substring(4, 6), 16),
      a: hexValue.length === 8 ? parseInt(hexValue.substring(6, 8), 16) : 255,
    };

    return result;
  }

  // 如果是 rgba(R, G, B, A) 格式
  const rgbaMatch = colorString.match(
    /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*([01](\.\d+)?)\)$/
  );
  if (rgbaMatch) {
    result = {
      r: parseInt(rgbaMatch[1], 10),
      g: parseInt(rgbaMatch[2], 10),
      b: parseInt(rgbaMatch[3], 10),
      a: Math.round(parseFloat(rgbaMatch[4]) * 255),
    };
    return result;
  }

  // 如果是 rgb(R, G, B) 格式
  const rgbMatch = colorString.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (rgbMatch) {
    result = {
      r: parseInt(rgbMatch[1], 10),
      g: parseInt(rgbMatch[2], 10),
      b: parseInt(rgbMatch[3], 10),
      a: 255,
    };
    return result;
  }

  // 如果无法匹配任何格式，返回 undefined
  return result;
}
